import { ProjectBasicContact } from "../ProjectInterface";
import { mapShareContacts, ShareContact } from "../ShareContactInterface";

export interface SubFolder {
    sub_folder_id: number;
    folder_id: number;
    sub_folder_name: string;
    type: string;
    is_default_folder: number;
    count: number;
    assign: ShareContact[],
    created_datatime: string;
}

export const mapSubFolder = (data: any): SubFolder => {
    if (!data) {
        throw new Error('Invalied SubFolder type')
    }

    const subFolder: SubFolder = {
        sub_folder_id: data.sub_folder_id,
        folder_id: data.folder_id,
        sub_folder_name: data.sub_folder_name,
        type: data.type,
        is_default_folder: data.is_default_folder,
        count: data.count,
        assign: mapShareContacts(data.assign),
        created_datatime: data.created_datatime,
    }

    return subFolder;
}

export const mapSubFolders = (data: any[]): SubFolder[] => {
    if (!Array.isArray(data)) {
        throw new Error('Invalid SubFolder data');
    }

    return data.map(mapSubFolder);
};

export interface SubFolderAndDocument {
    category: string;
    id: number;
    folder_id: number;
    title: string;
    created_datatime: string;
    //Sub folder
    type: string;
    is_default_folder: number;
    count: number;
    assign: ShareContact[],
    assignedContact: ProjectBasicContact[],
    //Document
    path: string;
}